import { render, staticRenderFns } from "./edit_item.vue?vue&type=template&id=d9ad5680"
import script from "./edit_item.vue?vue&type=script&lang=js"
export * from "./edit_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports